<template>
  <div :class="['app-root', bodyClass]" id="app">
    <ValidateDomain v-if="!isValidDomain" />
    <router-view v-else />
  </div>
</template>

<script>
import ValidateDomain from "@/components/probaworkflows_base_components/ValidateDomain/ValidateDomain.vue";

export default {
  props: {
    isValidDomain: {
      type: Boolean,
      required: true,
    },
  },
  components: { ValidateDomain },
  data() {
    return {
      hostname: window.location.hostname,
    };
  },
  computed: {
    bodyClass() {
      return this.hostname.includes("bolide.complyon") ? "bolide-domain" :
             this.hostname.includes("pulsecheck.complyon.ai") ? "pulsecheck-domain" :
             this.hostname.includes("ndabenitrust.complyon") ? "ndabenitrust-domain" :
             this.hostname.includes("trustfirst.probaanalytics") ? "trustfirst-domain" :
             this.hostname.includes("probaworkflows") ? "default-branding-domain" :
             this.hostname.includes("complyon.ai") ? "default-branding-domain" :
             this.hostname.includes("x-verdict") ? "xverdict-branding-domain" :
             this.hostname.includes("aic-one") ? "default-branding-domain" :
             this.hostname.includes("aicampus") ? "default-branding-domain" :
             this.hostname.includes("business.complyon") ? "complyon-branding-domain" :
             this.hostname.includes("rematholdings.complyon") ? "rematholdings-branding-domain" :
             this.hostname.includes("vettedafrica.complyon") ? "vetted-branding-domain" :
             this.hostname.includes("monitoring.dwypd.gov") ? "dwypd-branding-domain" :
             "";
    },
  },
};
</script>
